import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white customer-satisfaction-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-md-25 d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = { class: "chart" }
const _hoisted_6 = { class: "list ps-0 mb-0 list-unstyled text-center" }
const _hoisted_7 = { class: "d-flex align-items-center mb-10" }
const _hoisted_8 = { class: "fs-12 fw-medium text-black-emphasis text-uppercase lh-1 ms-8" }
const _hoisted_9 = { class: "d-flex align-items-end" }
const _hoisted_10 = { class: "mb-0 text-black-emphasis lh-1 fw-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.nom), 1),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"dropdown\"><button class=\"dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"flaticon-dots\"></i></button><ul class=\"dropdown-menu\"><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-view lh-1 me-8\"></i> View </a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-pen lh-1 me-8\"></i> Edit </a></li><li><a class=\"dropdown-item d-flex align-items-center\" href=\"javascript:void(0);\"><i class=\"flaticon-delete lh-1 me-8\"></i> Delete </a></li></ul></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_apexchart, {
          type: "pie",
          height: "240",
          id: "customerSatisfactionChart",
          options: _ctx.serieChart,
          series: _ctx.projects
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects.length, (i=0) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-inline-block text-start",
            key: i
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "d-block w-10 h-10 rounded-circle",
                style: _normalizeStyle(`background-color:${_ctx.colors[i-1]}`)
              }, null, 4),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.labels[i-1]), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.projects[i-1]), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}